import { ElementType, lazy, Suspense } from 'react';
import { SuspenseLoadingScreen } from 'src/components/loading-screen/LoadingScreen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<SuspenseLoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// Retry lazy loading when an error occurs
export const retryLazy = (componentImport: any) =>
  lazy(async () => {
    const pageAlreadyRefreshed = JSON.parse(
      window.localStorage.getItem('pageRefreshed') || 'false',
    );
    try {
      const component = await componentImport();
      window.localStorage.setItem('pageRefreshed', 'false');
      return component;
    } catch (error) {
      if (!pageAlreadyRefreshed) {
        window.localStorage.setItem('pageRefreshed', 'true');
        return window.location.reload();
      }
      throw error;
    }
  });

export const Page403 = Loadable(lazy(() => import('../screens/common/Page403')));
export const Page404 = Loadable(lazy(() => import('../screens/common/Page404')));
export const Page500 = Loadable(lazy(() => import('../screens/common/Page500')));
export const Home = Loadable(lazy(() => import('../screens/home/Home')));
export const PageError = Loadable(retryLazy(() => import('../screens/common/PageError')));
export const Login = Loadable(lazy(() => import('../screens/auth/login/Login')));
export const HospitalManagement = Loadable(
  lazy(() => import('../screens/hospital-management/HospitalManagement')),
);
export const PatientManagement = Loadable(
  lazy(() => import('../screens/patient-management/PatientManagement')),
);
export const ScenarioManagement = Loadable(
  lazy(() => import('../screens/scenario-management/ScenarioManagement')),
);
export const ServiceControl = Loadable(
  lazy(() => import('../screens/service-control/ServiceControl')),
);
export const TermsManagement = Loadable(
  lazy(() => import('../screens/terms-management/TermsManagement')),
);
export const FindId = Loadable(lazy(() => import('../screens/auth/find-id/FindId')));
export const FindIdEnd = Loadable(lazy(() => import('../screens/auth/find-id/FindIdEnd')));
export const ResetPwd = Loadable(lazy(() => import('../screens/auth/reset-pwd/ResetPwd')));
export const ResetPwdForm = Loadable(lazy(() => import('../screens/auth/reset-pwd/ResetPwdForm')));
export const ResetPwdEnd = Loadable(lazy(() => import('../screens/auth/reset-pwd/ResetPwdEnd')));
export const Register = Loadable(lazy(() => import('../screens/auth/register/Register')));
export const ExistId = Loadable(lazy(() => import('../screens/auth/register/exist-id/ExistId')));
export const RegisterForm = Loadable(
  lazy(() => import('../screens/auth/register/register-form/RegisterForm')),
);
export const RegisterEnd = Loadable(lazy(() => import('../screens/auth/register/RegisterEnd')));
export const PatientChart = Loadable(
  lazy(() => import('../screens/patient-management/patient-chart/PatientChart')),
);
export const PatientDiary = Loadable(
  lazy(() => import('../screens/patient-management/patient-diary/PatientDiary')),
);
export const ProfileManagement = Loadable(
  lazy(() => import('../screens/my-page/ProfileManagement')),
);
export const MemberWithdrawal = Loadable(lazy(() => import('../screens/my-page/MemberWithdrawal')));
export const ChangePassword = Loadable(lazy(() => import('../screens/my-page/ChangePassword')));
export const ChangeLanguage = Loadable(lazy(() => import('../screens/my-page/ChangeLanguage')));
export const UserManual = Loadable(lazy(() => import('../screens/user-manual/UserManual')));
